type Variant = (typeof variants)[number];

const variants = ["agrotrade", "cleverfarm", "mymex", "spzo"] as const;

export type { Variant };
export { variants };
